import { h, Component } from 'preact'
import { connect } from 'preact-redux'

import { answerChat, messageChat } from '../actions/chat'
import { initSession } from '../actions/session'
import { fetchGeolocation } from '../actions/geolocation'
import { listChat, currentQuestion, makeResults, chatComplete } from '../selectors/chat'
import { getLocation } from '../selectors/geolocation'
import Header from '../components/Header'
import ChatBot from '../components/ChatBot'
import Scrollable from '../components/Scrollable'

const mapStateToProps = (state) => ({
  history: listChat(state),
  question: currentQuestion(state),
  results: chatComplete(state) ? makeResults(state) : null,
  data: state.chat.answers,
  // location: getLocation(state),
  timestamps: state.chat.timestamps
})

function answerGoal(question, answer) {
  switch (question) {
    case 'name':
      return answer.length > 0 ? 'user_name' : null
    case 'email':
      return answer.length > 0 && !answer.toLowerCase().match(/нет/)
        ? 'user_email' : null
    case 'phone':
      return answer.length > 0 ? 'user_phone' : null
    default:
      return null
  }
}

const mapDispatchToProps = (dispatch) => ({
  onAnswer(question, answer) {
    const goal = answerGoal(question, answer)
    if (goal) {
      ym(53677870, 'reachGoal', goal)
    }
    dispatch(answerChat(question, answer))
  },
  onEnter() {
    dispatch(initSession())
    dispatch(fetchGeolocation())
  },
  onMessage(question) {
    dispatch(messageChat(question))
  }
})

class ChatContainer extends Component {
  state = {
    updates: 0
  }

  handleReady = () => {
    this.setState(prev => ({updates: prev.updates + 1}))
  }

  handleAnswer = (question, answer) => {
    const {onAnswer} = this.props
    onAnswer(question, answer)
    this.setState(prev => ({updates: prev.updates + 1}))
  }

  componentDidMount() {
    const {onEnter} = this.props
    onEnter()
  }

  render({onAnswer, ...props}, {updates}) {
    return (
      <Scrollable updates={updates}>
        <Header />
        <ChatBot {...props} onAnswer={this.handleAnswer} onReady={this.handleReady} />
      </Scrollable>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatContainer)



// WEBPACK FOOTER //
// ./containers/ChatContainer.js